import { render, staticRenderFns } from "./Institucional.vue?vue&type=template&id=4d9d8842&scoped=true&"
import script from "./Institucional.vue?vue&type=script&lang=js&"
export * from "./Institucional.vue?vue&type=script&lang=js&"
import style0 from "./Institucional.vue?vue&type=style&index=0&id=4d9d8842&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9d8842",
  null
  
)

export default component.exports